import { FcsFlag } from "../unleash";

export const FlagsNewPaymentPage = {
  new_payment_page_enable: new FcsFlag.Flag(false),
};

export function initFlagsNewPaymentPage() {
  FcsFlag.register("website", FlagsNewPaymentPage);
}

export function isNewPaymentPageEnabled() {
  return FlagsNewPaymentPage.new_payment_page_enable.isEnabled();
}
